import { render, staticRenderFns } from "./ContactExpedientsComponent.vue?vue&type=template&id=5be08a3e"
import script from "./ContactExpedientsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactExpedientsComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be08a3e')) {
      api.createRecord('5be08a3e', component.options)
    } else {
      api.reload('5be08a3e', component.options)
    }
    module.hot.accept("./ContactExpedientsComponent.vue?vue&type=template&id=5be08a3e", function () {
      api.rerender('5be08a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactExpedients/ContactExpedientsComponent.vue"
export default component.exports